import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js';
import {error, loading} from 'eduair-shared'

let app;

if (!app) {
    app = createApp(App).use(store).use(router).use(error).use(loading)

    app.mount('#app')
}